import { Loader2, WifiOff } from "lucide-react";

type PlayerDropsLoadingSpinnerProps = {
    isError?: boolean;
};

export function PlayerDropsLoadingSpinner({ isError }: PlayerDropsLoadingSpinnerProps) {
    if (isError) {
        return (
            <div className="h-full min-h-36 w-full flex flex-col items-center justify-center gap-4 text-center p-6 border border-destructive/20 bg-destructive/5 rounded-xl shadow-lg relative overflow-hidden group select-none animate-[fadeUp_0.3s_ease]">
                <div className="absolute inset-0 bg-gradient-to-br from-destructive/10 via-transparent to-transparent pointer-events-none" />
                
                {/* Glowing Error Icon */}
                <div className="w-14 h-14 rounded-full flex items-center justify-center bg-destructive/10 border border-destructive/25 text-destructive shadow-[0_0_15px_rgba(239,68,68,0.2)] animate-pulse">
                    <WifiOff className="size-6" />
                </div>
                
                <div className="flex flex-col gap-1.5 z-10">
                    <span className="font-mono text-xs font-bold tracking-widest text-destructive uppercase">
                        Diagnostics Offline
                    </span>
                    <span className="text-sm text-slate-400 max-w-md font-sans">
                        Unable to stream data from the txAdmin telemetry endpoint. Please check if the server is active.
                    </span>
                </div>
            </div>
        );
    } else {
        return (
            <div className="h-full min-h-36 w-full flex flex-col items-center justify-center gap-3 text-muted-foreground p-6">
                <Loader2 className="animate-spin size-10 text-scCyan opacity-90" />
                <span className="font-mono text-[10px] tracking-widest text-muted-foreground uppercase animate-pulse">
                    Streaming Telemetry...
                </span>
            </div>
        );
    }
}

type PlayerDropsMessageProps = {
    message: string;
};

export function PlayerDropsMessage({ message }: PlayerDropsMessageProps) {
    return (
        <div className="h-full min-h-36 w-full px-4 py-6 flex items-center justify-center text-xl tracking-wider text-muted-foreground/75 font-mono">
            {message}
        </div>
    )
}
